import { generalSettingsStateModel } from './stateModels';

export function generalSettings(state = generalSettingsStateModel, action) {
    switch (action.type) {
        default:
            return state
    }
}